
define('core/file',["require", "exports", './api_error'], function(require, exports, api_error) {
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;

    /**
    * Base class that contains shared implementations of functions for the file
    * object.
    * @class
    */
    var BaseFile = (function () {
        function BaseFile() {
        }
        BaseFile.prototype.sync = function (cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFile.prototype.syncSync = function () {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFile.prototype.datasync = function (cb) {
            this.sync(cb);
        };
        BaseFile.prototype.datasyncSync = function () {
            return this.syncSync();
        };
        BaseFile.prototype.chown = function (uid, gid, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFile.prototype.chownSync = function (uid, gid) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFile.prototype.chmod = function (mode, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFile.prototype.chmodSync = function (mode) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        BaseFile.prototype.utimes = function (atime, mtime, cb) {
            cb(new ApiError(14 /* ENOTSUP */));
        };
        BaseFile.prototype.utimesSync = function (atime, mtime) {
            throw new ApiError(14 /* ENOTSUP */);
        };
        return BaseFile;
    })();
    exports.BaseFile = BaseFile;
});
//# sourceMappingURL=file.js.map
;